import React, { Component } from 'react';
import PageEditor from '../PageEditor/PageEditor';
import './SelfPublish.css';
import mixins from '../../app-services/mixins';
import { readUrl } from '../PageEditor/support';

import FrontCover from "./FrontCover.txt";
import Copyright from "./Copyright.txt";
import Titlepage from "./Titlepage.txt";
import Dedication from "./Dedication.txt";
import Chaptertitle from "./Chaptertitle.txt";
import Authorandartist from "./Authorandartist.txt";
import Backcover from "./Backcover.txt";

import Personalize from '../common/Personalize/Personalize';

import ImageTextBolierplate from './Bolierplates/ImageTextBolierplate';

import { withRouter } from "react-router";

export class SelfPublish extends Component {
    constructor(props) {
        super(props);
        this.BOOKID = props.match.params.id;
        initialConstruct.bind(this)('SelfPublish');
        const book = props.store.book.selfpublish.chapterbook;
        this.state = {
            staticPages: {
                frontpage: FrontCover,
                copyright: Copyright,
                titlepage: Titlepage,
                dedication: Dedication,
                chaptertitle: Chaptertitle,
                authorandartist: Authorandartist,
                backcover: Backcover
            },
            savedBook: {},
            bolierplates: {},
            svgs: {},
            pages: [
                {
                    pagetype: "fulltext",
                    contentSize: 200,
                    name: `frontpage`,
                    label: `Front Cover`,
                    content: book && book[`frontpage`]
                },
                {
                    pagetype: "fulltext",
                    contentSize: 800,
                    name: `titlepage`,
                    label: `Titlepage`,
                    content: book && book[`titlepage`]
                },
                {
                    pagetype: "fulltext",
                    name: `copyright`,
                    label: `Copyright`,
                    content: book && book[`copyright`]
                },
                {
                    pagetype: "fulltext",
                    name: `dedication`,
                    label: `Dedication`,
                    content: book && book[`dedication`]
                },
                {
                    pagetype: "fulltext",
                    name: `chaptertitle`,
                    label: `Chapter Title`,
                    content: book && book[`chaptertitle`]
                },

                ...this.generateBlankPage(55),
                {
                    pagetype: "fulltext",
                    name: `authorandartist`,
                    label: `Author and Artist`,
                    content: book && book[`authorandartist`]
                },
                {
                    pagetype: "fulltext",
                    name: `backcover`,
                    label: `Back Cover`,
                    content: book && book[`backcover`]
                },
            ],
            overlayStyle: {}
        }
    }

    generateBlankPage(count = 55) {
        let arr = [];
        arr.length = count;
        arr = arr.fill({});
        let pages = arr.map((v, i) => {
            return {
                pagetype: "halftexthalfimage",
                name: `Page${i + 6}`,
                label: `Page ${i + 6}`,
                content: ImageTextBolierplate,
                contentSize:500
            }
        });
        return pages;
    }

    getContent(content, page) {
        let ele = mixins.getDataNode(content);
        //console.log({content,book:page,bolierplates:this.state.bolierplates});
        content = ele.innerHTML;
        return content;
    }

    getLatestBook() {
        return new Promise((resolve, reject) => {
            api.getUpdatedSelfBook({
                sessionId: localStorage.getItem("sessionID") || null,
                type:"chapterbook"
            }).then((responce) => {
                if (responce && responce.data) {
                    let payload = responce.data;
                    this.setState({
                        savedBook: payload
                    });
                    resolve(payload);
                } else {
                    resolve(this.state.savedBook);
                }
            }).catch(reject);
        })
    };

    onSave(payload, self) {
        const BOOKID = self.BOOKID;
        const { savedBook } = self.state;
        return new Promise((resolve, reject) => {
            mixins.checkLogin(self.history).then(() => {
                if (savedBook && savedBook.id) {
                    api.updateSelfPublish({
                        bookId: BOOKID,
                        savedBook: JSON.stringify(payload),
                        option: "dynamic",
                        sessionId: localStorage.getItem("sessionID") || null,
                        type:"chapterbook"
                    }, savedBook.id).then((responce) => {
                        self.getLatestBook().then((responce) => {
                            resolve(responce);
                        }).catch(reject);
                    });
                } else {
                    api.createSelfPublish({
                        bookId: BOOKID,
                        savedBook: JSON.stringify(payload),
                        option: "dynamic",
                        sessionId: localStorage.getItem("sessionID") || null,
                        file: null,
                        type:"chapterbook"
                    }).then((responce) => {
                        self.history.push(self.history.location.pathname+`/${responce.data.id}`);
                        setTimeout(()=>{
                            self.getLatestBook("createmsg").then((responce) => {
                                resolve(responce);
                            }).catch(reject);
                        });
                    });
                }     
            });
        });
    }
    onUpdate() {

    }

    updateBoilerplate() {
        return new Promise((resolve, reject) => {
            let { staticPages } = this.state;
            let promises = Object.entries(staticPages).map(([key, url]) => {
                return new Promise((resolve, reject) => {
                    readUrl(url).then((responce) => resolve({ key, responce })).catch(reject)
                })
            });
            let load = loader("Loading boilerplates please wait...");
            Promise.all(promises).then((responce) => {
                let bolierplates = responce.reduce((o, n) => ({ ...o, [n.key]: n.responce }), {});
                this.setState({
                    bolierplates: bolierplates
                });
                load.close();
                resolve(bolierplates);
            }).catch(()=>{load.close();reject();});
        });
    }

    onProceed() {
        this.updateData();
    }

    collectInfo() {
        let modal = alert((props) => (<Personalize alert={props} onProceed={() => this.onProceed()} />), "", "model", {
            footer: false,
            class: "personalize-col col-12 col-md-10 col-lg-10 col-xl-8",
            parentclass: "personalize-row row",
            options: {
            }
        });
    }

    updateData() {
        this.updateBoilerplate().then((bolierplates) => {
            this.getLatestBook().then((bookObj) => {
                let book = bookObj?.savedBook?.parse({}) || {};
                //console.log({ bookObj, book });
                this.setState({
                    pages: this.state.pages.map((o) => ({ ...o, content: this.getContent(book[o.name] || o.content || bolierplates[o.name] || "", o) }))
                });
            });
        });
    }

    componentDidMount() {
        this.updateData();
    }
    getNoticeMeesage() {
        let defaultmessage = "";
        let device = this.$store.device;
        if(["mob","small","tab", "lap"].includes(device)) {
          defaultmessage+="<br/><span style='font-size:12px; color:#cc3300; font-weight:400;'>Books Best view in Desktop version only</span>";
        }
        return defaultmessage;
      }

    render() {
        let noticeMessage = this.getNoticeMeesage();
        initialConstruct.bind(this)('SelfPublish');
        return (({ savedBook,pages, overlayStyle }, props, { onSave, onUpdate }) => (
            <div className='SelfPublish top-margin'>
                <PageEditor
                    pagePayload={pages}
                    onSave={(...arg) => onSave(...arg, this)}
                    onUpdate={onUpdate}
                    charcount={100}
                    lastPageNo={62}
                    overlay={false}
                    style={overlayStyle}
                    has={["chapter"]}
                    pageMode="mono"
                    bookDetails={savedBook}
                    message={noticeMessage}
                ></PageEditor>
            </div>
        ))(this.state, this.props, this);
    }
}

export default connect(withRouter(SelfPublish));